/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode"/>
define("SuiteCommerce.PagePrinter.ExtQRCode", ["require", "exports", "Handlebars", "SuiteCommerce.PagePrinter.ExtQRCode.View"], function (require, exports, Handlebars, QRCode_View_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QRCode = /** @class */ (function () {
        function QRCode() {
        }
        QRCode.install = function () {
            Handlebars.registerHelper('qrCode', function (options) {
                var qrOptions = options.hash && options.hash.encode ? options.hash : { encode: '' };
                var qrView = new QRCode_View_1.QRCodeView(qrOptions);
                return new Handlebars.SafeString("<div>" + qrView.render().$el.html() + "</div>");
            });
        };
        return QRCode;
    }());
    exports.QRCode = QRCode;
});
